export const isDateInRange = (date, minDate, maxDate) => {
    const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
    const minDateTime = minDate
        ? new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate()).getTime()
        : undefined;
    const maxDateTime = maxDate
        ? new Date(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate()).getTime()
        : undefined;
    return !((minDateTime && dateOnly < minDateTime) || (maxDateTime && dateOnly > maxDateTime));
};
export const formatDateKey = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
};
export const getVisibleMonthDates = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstMonth = new Date(year, month, 1);
    const secondMonth = new Date(year, month + 1, 1);
    return [firstMonth, secondMonth];
};
export const getVisibleMonthDatesForMobile = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstMonth = new Date(year, month, 1);
    const secondMonth = new Date(year, month + 1, 1);
    const thirdMonth = new Date(year, month + 2, 1);
    return [firstMonth, secondMonth, thirdMonth];
};
export const getSingleMonthDate = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return [new Date(year, month, 1)];
};
export const getVisibleMonthIndexes = (date) => {
    const currentMonth = date.getMonth();
    const nextMonth = (currentMonth + 1) % 12;
    return [currentMonth, nextMonth];
};
export const createPriceMap = (flightsData) => {
    const priceMap = {};
    Object.keys(flightsData).forEach((date) => {
        const flight = flightsData[date];
        priceMap[date] = flight.priceIndication;
    });
    return priceMap;
};
export const getPriceVariant = (priceIndication) => {
    const variantMap = {
        low: "good",
        medium: "neutral",
        high: "bad"
    };
    return variantMap[priceIndication] || "neutral";
};
export const getDateRangeFromVisibleMonthDates = (visibleMonthDates) => {
    if (visibleMonthDates.length === 0) {
        return ["", ""];
    }
    const today = new Date();
    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth();
    const firstMonthDate = visibleMonthDates[0];
    const lastMonthDate = visibleMonthDates[visibleMonthDates.length - 1];
    const firstYear = firstMonthDate.getFullYear();
    const firstMonth = firstMonthDate.getMonth();
    const lastYear = lastMonthDate.getFullYear();
    const lastMonth = lastMonthDate.getMonth();
    let startDate;
    if (todayYear === firstYear && todayMonth === firstMonth && today >= firstMonthDate) {
        startDate = new Date(todayYear, todayMonth, today.getDate());
    }
    else {
        startDate = new Date(firstYear, firstMonth, 1);
    }
    const lastDate = new Date(lastYear, lastMonth + 1, 0);
    const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };
    return [formatDate(startDate), formatDate(lastDate)];
};
export const getDateRangeFromVisibleMonths = (visibleMonths, baseDate) => {
    if (visibleMonths.length === 0) {
        return ["", ""];
    }
    const year = baseDate.getFullYear();
    const month = baseDate.getMonth();
    const firstMonthIndex = visibleMonths[0];
    const secondMonthIndex = visibleMonths[1];
    let firstYear = year;
    let secondYear = year;
    if (firstMonthIndex === 11 && secondMonthIndex === 0) {
        secondYear = year + 1;
    }
    else if (month === 11 && firstMonthIndex === 0) {
        firstYear = year + 1;
        secondYear = year + 1;
    }
    const firstDate = new Date(firstYear, firstMonthIndex, 1);
    const lastDate = new Date(secondYear, secondMonthIndex + 1, 0);
    const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };
    return [formatDate(firstDate), formatDate(lastDate)];
};
